import type { PropsWithChildren } from 'react';
import { Button } from './button';

export default function AuthPinButton({ children, onClick }: PropsWithChildren<{ onClick?: () => void }>) {
	return (
		<Button className='w-[60px] max-w-[60px] h-[60px] max-h-[60px] text-xl' variant='outline' onClick={onClick}>
			{children}
		</Button>
	);
}
